import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权
import { authorize } from '@/api/login'

// const whiteList = ['/login', '/login/**/*', '/404'] // 不重定向白名单

// const judgePermission = (path, whiteList) => {
//   let isPermitted = false
//   whiteList.map(str => {
//     str = str.replace(/([^*])\*([^*])/g, '$1[^\/]*$2')
//     str = str.replace(/([^*])\*$/g, '$1[^\/]*')
//     str = str.replace('**/', '([^\/]+\/)*')
//     str = '^' + str + '$'
//     if (path.match(new RegExp(str))) {
//       isPermitted = true
//       return true
//     }
//   })
//   return isPermitted
// }

router.beforeEach((to, from, next) => {
  NProgress.start()
  // if (getToken()) {
  if (to.path === '/login') {
    authorize().then(response => {
      if (response.status === 200) {
        window.location.href = response.data.redirectUrl
      } else {
        next()
        NProgress.done()
      }
    }).catch(() => {
      next()
      NProgress.done()
    })
  } else {
    next()
    NProgress.done()
  }
  // if (to.path === '/' || to.path === '/login') {
  //   next('/dashboard')
  //   NProgress.done()
  // } else {
  //   // if (!store.getters.roles || store.getters.roles.length === 0) {
  //   //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
  //   next()
  //   NProgress.done()
  //   //   }).catch(() => {
  //   //     store.dispatch('FedLogOut').then(() => {
  //   //       Message.error('验证失败,请重新登录')
  //   //       next({ path: '/login' })
  //   //     })
  //   //   })
  //   // } else {
  //   //   next()
  //   // }
  // }
  // } else {
  //   if (judgePermission(to.path, whiteList)) {
  //     next()
  //   } else {
  //     next('/login')
  //     NProgress.done()
  //   }
  // }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js